import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-acc-reports',
  templateUrl: './acc-reports.component.html',
  styleUrls: ['./acc-reports.component.css']
})
export class AccReportsComponent implements OnInit {

  constructor(public translate: TranslateService,
    public storage: LocalStorageService,) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
  ExpensesReport(){
    this.storage.store('stgTitle','Expenses from Date To Date')
    this.storage.store('stgHidBank',false)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',true)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  ExpensesbySupplierReport(){
    this.storage.store('stgTitle','Expenses by Supplier')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',false)
    this.storage.store('stgHidoption',false)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  ExpensesbyClassReport(){
    this.storage.store('stgTitle','Expenses by Type')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',false)
    this.storage.store('stgHidExpenses',false)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  RevenueReport(){
    this.storage.store('stgTitle','Revenue from Date To Date')
    this.storage.store('stgHidBank',false)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',true)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  PatientReport(){
    this.storage.store('stgTitle','Revenue by Patient')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',false)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',false)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  RevenueTypeReport(){
    this.storage.store('stgTitle','Revenue by Type')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',false)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',false)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }

  RevenueHospitalReport(){
    this.storage.store('stgTitle','Revenue By Branch')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',false)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',false)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  RevenueDoctorReport(){
    this.storage.store('stgTitle','Revenue By Doctor')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',false)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',false)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  RevenueExpensesReport(){
    this.storage.store('stgTitle','Cash/Bank Transactions')
    this.storage.store('stgHidBank',false)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',false)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)

  }
  PatientAccReport(){
    this.storage.store('stgTitle','Patient Acc. statement')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',true)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',false)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',false)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }

  ItemBalanceReport(){
    this.storage.store('stgTitle','Item Balances')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',false)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',false)
    this.storage.store('stgHidClass',false)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  ItemCardReport(){
    this.storage.store('stgTitle','Item Card')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',true)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',false)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',false)
    this.storage.store('stgHidPrice',true)
  }
  SalesReport(){
    this.storage.store('stgTitle','Invoices from Date to Date')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',true)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  VisitsShare(){
    this.storage.store('stgTitle','Visits Share from Date to Date')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',true)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  SuppervisionShare(){
    this.storage.store('stgTitle','Suppervision Share from Date to Date')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',true)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  DiscountReport(){
    this.storage.store('stgTitle','Discounts from date to date')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',true)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  SalesItem(){
    this.storage.store('stgTitle','Sales By Item')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',true)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',true)
  }
  SalesItemT(){
    this.storage.store('stgTitle','Item Sales')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',false)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',true)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',false)
    this.storage.store('stgHidClass',true)
    this.storage.store('stgHidItem',false)
    this.storage.store('stgHidPrice',true)
  }
  PriceList(){
    this.storage.store('stgTitle','Price List')
    this.storage.store('stgHidBank',true)
    this.storage.store('stgHidDate',true)
    this.storage.store('stgHidSupplier',true)
    this.storage.store('stgHidoption',true)
    this.storage.store('stgHidExpenses',true)
    this.storage.store('stgHidPatient',true)
    this.storage.store('stgHidRev',true)
    this.storage.store('stgHidHospital',true)
    this.storage.store('stgHidDoctor',true)
    this.storage.store('stgHidStore',true)
    this.storage.store('stgHidClass',false)
    this.storage.store('stgHidItem',true)
    this.storage.store('stgHidPrice',false)
  }
}
